import { MaterialIcon } from '@/components/MaterialIcon';
import { Button } from '@/components/Button';
import { Tag, type TagColor } from '@/components/Tag';
import type { AgentApiTagsRecord } from '@/types/serializers';

interface Props {
  tags: AgentApiTagsRecord[];
  editingTag: AgentApiTagsRecord | null;
  onEditTag: (tag: AgentApiTagsRecord) => void;
  onCreateTag: () => void;
  onDeleteTag: (tag: AgentApiTagsRecord) => void;
}

export default function TagManagementList({
  tags,
  editingTag,
  onEditTag,
  onCreateTag,
  onDeleteTag: _onDeleteTag,
}: Props) {
  return (
    <div className="flex w-[278px] shrink-0 flex-col gap-xs">
      <Button onClick={onCreateTag} color="secondary" size="md" className="w-full shrink-0">
        <MaterialIcon name="add" className="text-xl" />
        タグを新規追加
      </Button>

      {/* 184px = ヘッダー60 + 上下余白24 + 戻るボタン50 + 「タグを新規追加」ボタン50 */}
      <div className="-mx-xxs flex max-h-[calc(100vh_-_184px)] flex-col gap-xxs overflow-y-auto px-xxs">
        {tags.map((tag) => (
          <div
            key={tag.id}
            className={`flex h-12 shrink-0 cursor-pointer items-center justify-between gap-md rounded-sm p-sm shadow-layer1 hover:bg-gray ${
              editingTag?.id === tag.id ? 'bg-primary_lighten' : 'bg-white'
            }`}
            onClick={() => onEditTag(tag)}
          >
            <Tag color={tag.color_hex as TagColor}>{tag.name}</Tag>
            <MaterialIcon name="chevron_right" className="text-xl text-sub" />
          </div>
        ))}
      </div>
    </div>
  );
}
